import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { MessageCircle, X } from 'lucide-react';
import axios from 'axios';
import { motion, AnimatePresence } from 'framer-motion';

const Chatbot = () => {
  const { state } = useLocation(); // Get the state from the previous page
  const [isOpen, setIsOpen] = useState(false);
  const [query, setQuery] = useState("");
  const [response, setResponse] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [previousResponses, setPreviousResponses] = useState([]);

  // Parse the result from the state
  const result = state?.result;
  const parsedResult = result ? JSON.parse(result) : null;

//   useEffect(() => {
//     if (result) {
//       setResponse(result); // Set the fetched data in the response state
//     }
//   }, [result]);

  const limitWords = (text, limit = 500) => {
    const words = text.split(/\s+/);
    if (words.length > limit) {
      return words.slice(0, limit).join(' ') + '... (Response truncated)';
    }
    return text;
  };

  const handleQuerySubmit = async (e) => {
    e.preventDefault();

    if (!query.trim()) return;

    setIsLoading(true);
    setResponse("");

    try {
      const res = await axios.post(`http://localhost:5888/query`, { query });

      const limitedResponse = limitWords(res.data.response);

      // Add to previous responses
      setPreviousResponses((prev) => [
        { query, response: limitedResponse },
        ...prev,
      ]);

      setResponse(limitedResponse);
    } catch (error) {
      console.error("Error fetching chatbot response:", error);
      setResponse("Oops! Something went wrong. Please try again later.");
    } finally {
      setIsLoading(false);
      setQuery(""); // Clear input after submission
    }
  };

  const toggleChatbot = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="relative">
      {/* Chatbot Toggle and Modal */}
      <div className="fixed bottom-6 right-6 z-50">
        {/* Floating Toggle Button */}
        <motion.button
          onClick={toggleChatbot}
          whileHover={{ 
            scale: 1.2,
            rotate: [(Math.random() - 0.5) * 10, 0],
            transition: {
              type: 'spring',
              stiffness: 300,
              damping: 10
            }
          }}
          whileTap={{ scale: 0.95 }}
          className="focus:outline-none"
        >
          <motion.div
            initial={{ 
              scale: 1,
              rotateX: 0,
              rotateY: 0,
              translateZ: 10
            }}
            whileHover={{
              rotateX: 0,
              rotateY: 0,
              translateZ: 20,
              transition: { type: 'spring', stiffness: 300, damping: 15 }
            }}
            style={{
              perspective: '800px',
              display: 'inline-block'
            }}
          >
            <img
              src="/img/eva.png"
              alt="Chatbot Avatar"
              className="w-20 h-20 "
            />
          </motion.div>
        </motion.button>

        {/* Chatbot Modal */}
        {isOpen && (
          <div className="absolute bottom-20 right-20 w-96 bg-white rounded-lg shadow-2xl border border-gray-200 p-6 transition-all duration-300 ease-in-out">
            {/* Chatbot Query Section */}
            <form onSubmit={handleQuerySubmit} className="space-y-4">
              <div>
                <label
                  htmlFor="query"
                  className="block text-sm font-medium text-gray-700 mb-1"
                >
                  Your Question
                </label>
                <input
                  type="text"
                  id="query"
                  value={query}
                  onChange={(e) => setQuery(e.target.value)}
                  className=" text-black w-full px-3 py-2 border border-gray-900 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                  placeholder="What would you like to know?"//entering query colour
                />
              </div>

              <button
                type="submit"
                disabled={isLoading}
                className="w-full bg-blue-500 text-white py-2 rounded-md hover:bg-blue-600 transition duration-300 disabled:opacity-50"
              >
                {isLoading ? "Searching..." : "Ask"}
              </button>
            </form>

            {/* Scrollable Response History */}
            <div className="mt-4 max-h-64 overflow-y-auto space-y-3">
              {/* Current Response
              {response && (
                <div className="p-3 bg-blue-50 rounded-md border border-blue-200">
                  <h3 className="text-sm font-semibold text-blue-700 mb-2">
                    Latest Response:
                  </h3>
                  <p className="text-gray-800 text-sm">{response}</p>
                </div>
              )} */}

              {/* Previous Responses */}
              {previousResponses.slice(0, 5).map((prevResponse, index) => (
                <div
                  key={index}
                  className="p-3 bg-gray-50 rounded-md border border-gray-200"
                >
                  <h4 className="text-xs font-medium text-gray-600 mb-1">
                    Q: {prevResponse.query}
                  </h4>
                  <p className="text-gray-800 text-sm">
                    {prevResponse.response}
                  </p>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Chatbot;


